<template>
    <shop-settlement-info-card title="정산정보" :data="infos" />
</template>

<script>
import dayjs from "dayjs";
import shopSettlementInfoCard from "../../dumb/shop-settlement-info-card.vue";
export default {
    components: { shopSettlementInfoCard },
    props: {
        settlement: {
            type: Object,
        },
    },
    computed: {
        period() {
            const theDay = dayjs(this.settlement.createdAt).subtract(1, "day");
            const start = theDay.format("YYYY.MM.DD");
            const end = theDay.format("YYYY.MM.DD");
            return `${start} - ${end}`;
        },

        totalAmount() {
            const { totalAmount } = this.settlement;

            return totalAmount ? `${totalAmount.format()} 원` : "0 원";
        },

        settlesAt() {
            return dayjs(this.settlement.settlesAt).format("YYYY.MM.DD");
        },

        updatedAt() {
            return dayjs(this.settlement.updatedAt).format("YYYY.MM.DD HH:mm:ss");
        },

        isDone() {
            if (this.settlement.isDone) return "정산 완료";

            const today = dayjs(),
                settlesAt = dayjs(this.settlement.settlesAt);

            if (today.isSame(settlesAt, "day") || today.isAfter(settlesAt)) return "정산 미완료";
            else return "정산 예정";
        },

        infos() {
            return [
                { label: "정산기간", value: this.period },
                { label: "정산예상일", value: this.settlesAt },
                { label: "정산예상금액", value: this.totalAmount, cols: 4 },
                { label: "정산문서갱신일", value: this.updatedAt, cols:4 },
                { label: "정산여부", value: this.isDone, cols:4 },
            ];
        },
    },
};
</script>

<style></style>
